module.exports = __webpack_public_path__ + "img/emptyRecord.373ab69f.png";